import { Empty, Table } from "antd";
import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
class DataSourceMainSearch extends React.Component {
  render() {
    const {
      columns,
      dataSource,
      onChange,
      tableParams,
      getRowClassName,
      loading,
      t,
    } = this.props;
    // if (!isSearching) {
    //   return null;
    // }
    return (
      <div className="p-1">
        <Table
          dataSource={dataSource || []}
          columns={columns}
          scroll={{ x: "max-content" }}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={t("No data")}
              />
            ),
          }}
          loading={loading}
          onChange={onChange}
          rowClassName={getRowClassName}
          pagination={{
            ...tableParams.pagination,
            showSizeChanger: true,
            locale: {
              items_per_page: `/ ${t("paged")}`, 
            },
            showTotal: (total, range) => {
              // คำนวณหน้าปัจจุบัน
              const currentPage = tableParams.pagination.current;
              // คำนวณจำนวนหน้าทั้งหมด
              const totalPages = Math.ceil(total / tableParams.pagination.pageSize);

              return (
                <span>
                  {/* แสดง: หน้า 1 จาก 10 | แสดง 1-10 จาก 100 รายการ */}
                  <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                  <span style={{ marginLeft: 10 }}>
                    {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                  </span>
                </span>
              );
            },
          }}
        />
      </div>
    );
  }
}
const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});
export default connect(
  mapStateToProps,
  {},
)(withTranslation()(DataSourceMainSearch));
